import moment, { Moment } from 'moment';
import { AllocationEvent } from 'components/organisms/resource-management/event-types';
import { ignoreMinutesIfZero } from 'components/organisms/resource-management/utils/dates';
import { useTranslate } from 'hooks/use-translation';

export const allocationTooltip = (
  {
    startDate,
    endDate,
    totalMinutes,
    minutes,
  }: Pick<
    AllocationEvent,
    | 'startDate'
    | 'endDate'
    | 'projectPhase'
    | 'totalMinutes'
    | 'minutes'
    | 'billable'
  >,
  relativeDate: Moment,
  translate: ReturnType<typeof useTranslate>,
  isHoursPerWeek?: boolean,
): string => {
  if (isHoursPerWeek) {
    return `<div><span>${translate(
      'resource_management.allocation_event.tooltip.dates',
    )}:</span><strong> ${translate(
      'templates.resource_management.tooltips.dates.hours_per_week',
      {
        startWeek: moment(startDate).diff(relativeDate, 'week') + 1,
        duration:
          moment(endDate)
            .add(1, 'minute')
            .subtract(1, 'day')
            .diff(moment(startDate), 'week') + 1,
      },
    )}</strong></div>
    <div><span>${translate(
      'resource_management.allocation_event.tooltip.allocated',
    )}:</span><strong> ${ignoreMinutesIfZero(totalMinutes)}`;
  }

  return `<div><span>${translate(
    'resource_management.allocation_event.tooltip.dates',
  )}:</span><strong> ${translate(
    'templates.resource_management.tooltips.dates',
    {
      startDay: moment(startDate).diff(relativeDate, 'day'),
      duration: moment(endDate).diff(moment(startDate), 'day') + 1,
    },
  )}</strong></div>
  <div><span>${translate(
    'resource_management.allocation_event.tooltip.allocated',
  )}:</span><strong> ${ignoreMinutesIfZero(
    totalMinutes,
  )}</strong> (${ignoreMinutesIfZero(minutes)}/d)</div>`;
};
